import React, { useEffect, useCallback, useState } from 'react'
import { useHistory, useLocation } from 'react-router-dom'

import { Col, Row } from 'react-bootstrap'
import { useSelector } from 'react-redux'
import { getAccountListSelector } from '../../store/selectors/app.selector'
import PaymentsService from '../../services/payments.service'
import LayoutWithAccountCard from '../Layout/layout-account-card'


export default function TransferBillerServicesView() {
  const history = useHistory()
  const location = useLocation()
  const accounts = useSelector(getAccountListSelector) || []
  const [billerList, setBillerList] = useState([])
  const [data, setData] = useState({url:"",breadCrumb:""})

  useEffect(() => {
    location.pathname.includes('/transfers')&&setData({url:'/transfers',breadCrumb:'TRANSFERS_BILLER_SERVICES_VIEW'})
    location.pathname.includes('/accounts') &&setData({url:'/accounts',breadCrumb:'ACCOUNTS_BILLER_SERVICES_VIEW'})
    if (location?.state === undefined || location?.state === null) {
      history.push(`${data.url}/quick-pay`)
      return
    }
    getBillProducts()
  }, [])

  const getBillProducts = useCallback(async () => {
    try {
      const { categoryDetails } = location.state
      const response = await PaymentsService.getAllBillers({
        fetchServices: true,
        fetchProducts: true,
        module:'TRANSFER'
      })
      if (response.status === 200) {
        let serviceDetails = response.data['categories'].filter(
          (ele) => ele.category === categoryDetails.category,
        )[0].services
        // console.log(serviceDetails)
        serviceDetails.forEach((element) => {
          element.title = element.description
          element.desc = element.description
          element.icon = element.logo
          element.key = element.serviceId
        })
        setBillerList(serviceDetails)
      }
    } catch (err) {
      console.log(err)
    }
  }, [])

  const handleMenuCallback = useCallback((option) => {}, [])

  return (
    <LayoutWithAccountCard breadCumKey={data.breadCrumb}>
      <Row>
        {billerList.map((option, index) => (
          <Col
            xs={'auto'}
            sm={'auto'}
            md={'auto'}
            key={index}
            className='account-menu-card'
            onClick={() =>
              accounts.length > 0
                ? history.push({
                    pathname: `${data.url}/quick-pay/services/product`,
                    state: { billerDetails: option },
                  })
                : ''
            }>
            <img width={52} height={40} src={option?.icon} />
            <h2>{option?.description}</h2>
            <span>{option.title}</span>
          </Col>
        ))}
      </Row>
      </LayoutWithAccountCard>
  )
}
